import { createContext, ReactNode, useState } from 'react';

export const AdminModalContext = createContext({
    currentModal: "",
    setCurrentModal: (currentModal:string)=>{}
})

export default function AdminModalContextProvider({children}:{children:ReactNode}){

    const [currentModal, setCurrentModal] = useState("")

    return(
        <AdminModalContext.Provider value={{currentModal, setCurrentModal}}>
            {children}
        </AdminModalContext.Provider>
    )
    
}